__webpack_require__.p = "/xboard-react/";